import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const TurbSteam = {
  id: "10",
  name: "Turbina",
  mainClass: "Rotativos",
  subtype: "Vapor",
  variables: [],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.angularSpeed,
      unit: unitDefault.angularSpeed.metric,
      code: "turbineSpeed"
    },
    {
      value: 0,
      type: unitTypes.power,
      unit: unitDefault.power.metric,
      code: "turbinePower"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "turbineTemperatureIn"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "turbinePressureIn"
    },
    {
      value: "Generator",
      type: "unique",
      unit: "",
      code: "turbineDriven"
    },
    {
      value: 2,
      type: "unique",
      unit: "Stages",
      code: "turbineNumberOfStages"
    },
    {
      value: 0,
      type: unitTypes.angularSpeed,
      unit: unitDefault.angularSpeed.metric,
      code: "turbineMaxSpeed"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "turbineExhaustPressure"
    },
    {
      value: 0,
      type: unitTypes.angularSpeed,
      unit: unitDefault.angularSpeed.metric,
      code: "turbineTripSpeed"
    }
  ]
};
